import { render } from "./AdminInvitationsAdd.vue?vue&type=template&id=49864347&scoped=true"
import script from "./AdminInvitationsAdd.vue?vue&type=script&lang=js"
export * from "./AdminInvitationsAdd.vue?vue&type=script&lang=js"

import "./AdminInvitationsAdd.vue?vue&type=style&index=0&id=49864347&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49864347"]])

export default __exports__